exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3KC-chQiC0X5BMfouGicvC .table-container .b-table tr:hover td{background-color:dycolor-internal(!background,@primary);color:dycolor-internal(!color,@theme-white)}._3KC-chQiC0X5BMfouGicvC .page-item .page-link{color:dycolor-internal(!pagination-text,@theme-black)}._3KC-chQiC0X5BMfouGicvC .page-item.active .page-link{background-color:dycolor-internal(!pagination-active-background,@secondary);border-color:dycolor-internal(!pagination-active-background,@secondary);color:dycolor-internal(!pagination-active-text,@theme-white)}._3KC-chQiC0X5BMfouGicvC .main-input .clear{color:dycolor-internal(!clear-value-color,@theme-error)}\n", ""]);

// exports
exports.locals = {
	"root": "_3KC-chQiC0X5BMfouGicvC"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js?colors!./~/sass-loader/lib/loader.js?outputStyle=compressed!./src/gotu-vue-common/src/components/search-table/SearchTable.scss
// module id = 916
// module chunks = 1